module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-anna-shvets-4226140-small-1299aa4ae7ae1aa89e19d6fcc70f68c6.jpg";